import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { getFacilitiesDetails, getStaffDetails } from "../../api/dataCapture";
import { setFacilitiesDetails, setStaffDetails } from "../../redux/reducers/dataCaptures";

const GroundSelectAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, label, variant, isError, errorMessage, isReadOnly } = props;
    const groundList = useSelector((state:any) => state.dataCaptures.facilityDetails);
    const currentClub = useSelector((state:any) => state.clubDetails);
    const [isFetching, setIsFetching] = useState(false);
    const [t] = useTranslation();
    const [options, setOptions] = useState([]);
    const dispatch = useDispatch();

    const updateOptions = (list:any) => {      
        const updatedOptions = list?.map((item:any) => {return {id: item?.id, name: item?.facilityName}});
        const tempOptions:any = updatedOptions ? [{ id: -1, name: t('DC_NONE') }, ...updatedOptions] : [{ id: -1, name: t('DC_NONE') }];
        setOptions(tempOptions);
    }
    const fetchFacilityList = async () => {
        setIsFetching(true);
        const response = await getFacilitiesDetails({ clubId: currentClub?.id, isPast: false });
        dispatch(setFacilitiesDetails(response));
        setIsFetching(false);
        updateOptions(response);
    }
    useEffect(() => {
        !isFetching && currentClub && currentClub?.id &&  
        (groundList == undefined || groundList?.length == 0) && fetchFacilityList();
        groundList && groundList?.length > 0 && updateOptions(groundList);
    }, [selectedValues, groundList]);

    const manageFacilitySelect = (d:any) => {
      let tempStaffs = [];
      const index = selectedValues?.findIndex((item:any) => item == d.id);
      if(index !== -1) {
        tempStaffs = selectedValues?.filter((item:any) => item != d.id);
      } else {
        tempStaffs = [...selectedValues, parseInt(d.id)];
      }
      manageSelect(tempStaffs);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageFacilitySelect} 
            label={label}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            variant={variant}
            isError={isError}
            errorMessage={errorMessage}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default GroundSelectAutocomplete;